import seqStore from '../../store/seqStore'

export default function Transpose() {
    const currentTrack = seqStore((state) => state.settings.currentTrack)
    const semitone = seqStore((state) => state.settings.semitone)
    const setSemitone = seqStore((state) => state.setSemitone)

    // TRANSPOSE CONTROLS
    const handleSemitone = (e) => {
        const value = e.target.value
        setSemitone(currentTrack, value)
    }

    const resetSemitone = () => {
        setSemitone(currentTrack, 0)
    }
    
    return (
        <div id='transposeInput'>
            <label htmlFor="root note"><p>Transpose <span>{semitone[currentTrack]}</span></p></label>
            <input id='enabledInput' type="range" min={-12} max={12} step='1' value={semitone[currentTrack]} onChange={e => handleSemitone(e)} onDoubleClick={resetSemitone}/>
        </div>    
    )
}
